// extracted by mini-css-extract-plugin
module.exports = {"base":"PageMessage_base__22RzG","content":"PageMessage_content__pXu8k"};